import { render, staticRenderFns } from "./ResourcesValidateGenerateResultModal.vue?vue&type=template&id=b20c7938"
import script from "./ResourcesValidateGenerateResultModal.vue?vue&type=script&lang=js"
export * from "./ResourcesValidateGenerateResultModal.vue?vue&type=script&lang=js"
import style0 from "./ResourcesValidateGenerateResultModal.vue?vue&type=style&index=0&id=b20c7938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports